// extracted by mini-css-extract-plugin
module.exports = {"Container":"Player_Container__3zUpa","Player":"Player_Player__NBUVl"};